import * as React from 'react';
import VariantToSvg from './VariantToSvg';

export type Variant = keyof typeof VariantToSvg;

interface Props {
  variant: Variant;
}

const Asset: React.FC<Props> = ({ variant }) => VariantToSvg[variant];

export { Asset };
